import React from 'react';

function AiTalk() {
  return (
    <button className="px-4 py-2 bg-yellow-400 text-black rounded hover:bg-yellow-500">
      talk to assistant
    </button>
  );
}

export default AiTalk;
